import { render, staticRenderFns } from "./responsible_person_order.vue?vue&type=template&id=221c35fe&scoped=true"
import script from "./responsible_person_order.vue?vue&type=script&lang=js"
export * from "./responsible_person_order.vue?vue&type=script&lang=js"
import style0 from "./responsible_person_order.vue?vue&type=style&index=0&id=221c35fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221c35fe",
  null
  
)

export default component.exports